import filesize from "../../utils/filesize";

const SizeField = ({ source, record }) => filesize(record[source]);

export default SizeField;
